/**
 * CommonHTMLHelpStyle.ts
 */
export class CommonHTMLHelpStyle {
}
CommonHTMLHelpStyle.MAIN_DIV_ID = "help";
CommonHTMLHelpStyle.SUFFIX_KEY_H3 = "main";
CommonHTMLHelpStyle.SUFFIX_KEY_H4 = "title";
CommonHTMLHelpStyle.SUFFIX_KEY_P = "line";
//# sourceMappingURL=CommonHTMLHelpStyle.js.map